export default "__VITE_ASSET__BxV5jwhX__"